export const GET_TEMPLATE_DOWNLOAD_RANKING = 'GET_TEMPLATE_DOWNLOAD_RANKING'
export const SET_IS_LOADING = 'SET_IS_LOADING'
export const GET_TEMPLATE_EDITED_RANKING = 'GET_TEMPLATE_EDITED_RANKING'
export const DOWNLOAD_CHANGE_CRITERIA = 'DOWNLOAD_CHANGE_CRITERIA'
export const EDIT_CHANGE_CRITERIA = 'EDIT_CHANGE_CRITERIA'
